module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page terms-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.$vuetify.breakpoint.width >= 968) ? _c('div', {
    staticClass: "page-left",
    staticStyle: {
      "width": "unset"
    }
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('v-navigation-drawer', {
    attrs: {
      "permanent": "",
      "fixed": "",
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "page-title"
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.tabs), function(t) {
    return _c('v-list-tile', {
      key: t.id,
      class: {
        active: t.id == _vm.currentTab
      },
      staticStyle: {
        "line-height": "3"
      },
      attrs: {
        "href": ("#" + (t.id))
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(t.id)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(t.title) + " ")])], 1)
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [(_vm.$vuetify.breakpoint.width < 968) ? _c('div', [_c('div', {
    staticClass: "page-title"
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.tabs), function(t) {
    return _c('v-list-tile', {
      key: t.id,
      class: {
        active: t.id == _vm.currentTab
      },
      staticStyle: {
        "line-height": "3"
      },
      attrs: {
        "href": ("#" + (t.id))
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(t.id)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(t.title) + " ")])], 1)
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'terms_of_use') ? _c('terms-of-use-tab') : (_vm.currentTab == 'community_guidelines') ? _c('community-guidelines-tab') : (_vm.currentTab == 'privacy_policy') ? _c('privacy-policy-tab') : (_vm.currentTab == 'privacy_choice') ? _c('privacy-choice-tab') : (_vm.currentTab == 'copyright_policy') ? _c('copyright-policy-tab') : (_vm.currentTab == 'trademark_policy') ? _c('trademark-policy-tab') : (_vm.currentTab == 'gdpr') ? _c('gdpr-tab') : (_vm.currentTab == 'cookie_policy') ? _c('cookie-policy-tab') : (_vm.currentTab == 'sample_clearance') ? _c('sample-clearance-tab') : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66eb8d22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/terms/index.vue
// module id = 1754
// module chunks = 180